export const SEND_ADDRESS_DETAILS_REQUEST = 'SEND_ADDRESS_DETAILS_REQUEST';
export const SEND_ADDRESS_DETAILS_SUCCESS = 'SEND_ADDRESS_DETAILS_SUCCESS';
export const SEND_ADDRESS_DETAILS_FAILURE = 'SEND_ADDRESS_DETAILS_FAILURE';
export const sendObAddressDetailsSuccess = (payload) => ({
    type: SEND_ADDRESS_DETAILS_SUCCESS,
    payload,
});
export const sendObAddressDetailsRequest = (payload) => ({
    type: SEND_ADDRESS_DETAILS_REQUEST,
    payload,
});
export const sendObAddressDetailsFailure = (payload) => ({
    type: SEND_ADDRESS_DETAILS_FAILURE,
    payload,
});
